var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentsEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3213 7.50002C12.0254 7.50002 11.7855 7.73986 11.7855 8.03574V13.3928C11.7855 13.6887 11.5457 13.9285 11.2498 13.9285H1.60712C1.31125 13.9285 1.0714 13.6887 1.0714 13.3928V2.67865C1.0714 2.38278 1.31125 2.14294 1.60712 2.14294H8.03561C8.33148 2.14294 8.57132 1.90309 8.57132 1.60722C8.57132 1.31135 8.33148 1.07153 8.03561 1.07153H1.60712C0.719532 1.07153 0 1.79107 0 2.67865V13.3928C0 14.2804 0.719532 14.9999 1.60712 14.9999H11.2499C12.1374 14.9999 12.857 14.2804 12.857 13.3928V8.03571C12.857 7.73986 12.6171 7.50002 12.3213 7.50002Z",
    fill: "#727E8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3995 0.600855C14.0148 0.21615 13.4931 6.77675e-05 12.9491 0.000130546C12.4048 -0.00143891 11.8825 0.21502 11.499 0.6012L4.44259 7.65697C4.38405 7.71595 4.33988 7.78764 4.31349 7.86643L3.24208 11.0807C3.14857 11.3614 3.30034 11.6647 3.58105 11.7582C3.63551 11.7763 3.69255 11.7856 3.74993 11.7857C3.80743 11.7856 3.86459 11.7763 3.91921 11.7584L7.13346 10.687C7.2124 10.6606 7.28412 10.6162 7.34292 10.5573L14.3993 3.50099C15.2002 2.70019 15.2002 1.40175 14.3995 0.600855Z",
    fill: "#727E8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentsEditIcon);
export default __webpack_public_path__ + "static/media/contents-edit-icon.1aa3c721.svg";
export { ForwardRef as ReactComponent };